export default __webpack_public_path__ + "static/RobotoMono-Regular-ee8ccca0222ebd212fc9fbc17745480b.woff";